import { merge } from 'lodash-es';

import createNavigation, { GET_SITE_NAVIGATION } from '~coreModules/nav/js/nav-store';
import { PROFILE_MODULE_NAME } from '~modules/profile/js/profile-store';
import { BOX_MODULE_NAME } from '~modules/box/js/box-store';
import {
    NAVIGATION_TREE_DEPTH,
    HEADER_NAV_ROOT_SLUG,
} from '~coreModules/nav/js/nav-constants';

import { buildNavigationTreeForSlug } from '~coreModules/nav/js/nav-utils';

import { getChannelForSubscriptionStatus } from '~modules/nav/js/nav-utils';
import { userIsEligibleToViewContent } from '~modules/contentful/js/contentful-utils';

export { NAVIGATION_MODULE_NAME, GET_SITE_NAVIGATION } from '~coreModules/nav/js/nav-store';

export const SET_SITE_NAVIGATION = 'SET_SITE_NAVIGATION';

export const GET_RENT_SITE_NAVIGATION = 'GET_RENT_SITE_NAVIGATION';

export default function createRentNavigation(logger, config) {
    const coreNavigation = createNavigation(logger, config);

    return merge(coreNavigation, {
        actions: {
            async [GET_RENT_SITE_NAVIGATION]({ dispatch, rootGetters }) {
                const { loggedIn: isLoggedIn } = rootGetters;
                const effectiveSubscriptionStatus = rootGetters[`${PROFILE_MODULE_NAME}/effectiveSubscriptionStatus`];

                await dispatch(GET_SITE_NAVIGATION,
                    getChannelForSubscriptionStatus(isLoggedIn, effectiveSubscriptionStatus));
            },
        },
        getters: {
            /* hierarchical header navigation items */
            headerNav(state, getters, rootState, rootGetters) {
                const { flatNavigation } = state;
                const { appBaseUrl } = rootGetters;

                return buildNavigationTreeForSlug({
                    slug: HEADER_NAV_ROOT_SLUG,
                    flatNavigation,
                    logger,
                    depth: NAVIGATION_TREE_DEPTH,
                    appBaseUrl,
                });
            },
            eligibleNavContent: (state, getters, rootState, rootGetters) => {
                const { navigationContent } = state;
                const { loggedIn: isLoggedIn } = rootGetters;
                const effectiveSubscriptionStatus = rootGetters[`${PROFILE_MODULE_NAME}/effectiveSubscriptionStatus`];
                const hasRecentOrder = rootGetters[`${BOX_MODULE_NAME}/hasRecentOrder`];
                const boxOrderStatus = rootState[BOX_MODULE_NAME]?.boxOrderStatus;

                return navigationContent.filter(content => userIsEligibleToViewContent({
                    eligibilityRules: content.eligibility,
                    isLoggedIn,
                    boxOrderStatus,
                    subscriptionStatus: effectiveSubscriptionStatus,
                    hasRecentOrder,
                }));
            },
        },
    });
}
